const Gretting = () => {
  var todayDate = new Date();
  var currentHour = todayDate.getHours();
  let gretting;

  if (currentHour < 12) {
    gretting = "Good Morning";
  } else if (currentHour < 18) {
    gretting = "Good Afternoon";
  } else {
    gretting = "Good Evening";
  }
  return gretting;
};

export default Gretting;
